<template>
  <div class="not-found">
    <NotFound2
      type="404"
      title="Página não encontrada"
      text="A página que você procura não existe."
    >
        <v-btn rounded dark color="#0088FF" @click="open" >voltar ao início</v-btn>
    </NotFound2>
  </div>
</template>

<script>
import NotFound2 from "@/components/NotFound.vue";

export default {
  name: "NotFound",
  components: {
    NotFound2
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Public"
    });
  },
  methods: {
    open() {
        this.$router.replace({ name: "Home" });
    } 
  }
};
</script>

<style scoped>
.not-found {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
</style>
